/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trigger_ManualInputs */

const cs_trigger_manual = /** @type {(inputs: Trigger_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ručně`)
};

const en_trigger_manual = /** @type {(inputs: Trigger_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual`)
};

/**
* | output |
* | --- |
* | "Manual" |
*
* @param {Trigger_ManualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const trigger_manual = /** @type {((inputs?: Trigger_ManualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trigger_ManualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trigger_manual(inputs)
	return cs_trigger_manual(inputs)
});